import { Flex, List } from "antd";
import { FC } from "react";
import { TaskTakeDebt } from "tm-shared/types";
import { formatUAHStandard } from "tm-shared/utils";

import { PrimaryText, SecondaryText } from "@/components/Typography/Styled";

import { TaskViewModal } from "../TaskViewModal";

interface TakeDebtViewModalProps {
    task: TaskTakeDebt;
    onClose: () => void;
}

export const TakeDebtViewModal: FC<TakeDebtViewModalProps> = ({
    task,
    onClose,
}) => {
    const payload = task.payload;
    const completedAt = task?.completedAt;

    if (!payload || !completedAt) {
        return null;
    }

    return (
        <TaskViewModal title={task.name} onClose={onClose} taskInfo={task.info}>
            <Flex vertical gap={16}>
                {payload.result === true ? (
                    <Flex vertical gap={16}>
                        <Flex gap={8}>
                            <SecondaryText>Сума:</SecondaryText>

                            <PrimaryText
                                $textColor="accent"
                                fontWeight="500"
                                fontSize={16}
                            >
                                {formatUAHStandard(payload.amount)}
                            </PrimaryText>
                        </Flex>

                        {payload.consignmentsIds?.length > 0 && (
                            <Flex vertical>
                                <SecondaryText>
                                    Накладні ({payload.consignmentsIds.length}):
                                </SecondaryText>

                                <List
                                    dataSource={payload.consignmentsIds}
                                    renderItem={(id, index) => (
                                        <List.Item>
                                            <PrimaryText>
                                                {index + 1}. {id}
                                            </PrimaryText>
                                        </List.Item>
                                    )}
                                />
                            </Flex>
                        )}
                    </Flex>
                ) : (
                    <Flex vertical gap={4}>
                        <SecondaryText>Коментар:</SecondaryText>

                        <PrimaryText fontSize={16}>
                            {payload?.comment}
                        </PrimaryText>
                    </Flex>
                )}
            </Flex>
        </TaskViewModal>
    );
};
